import DirectusSDK from '@directus/sdk-js';
import Vue from 'vue';
import router from '@/router/index';
import i18n from '@/i18n';
import { clearUserData } from '@/services/auth';

const client = new DirectusSDK({
  url: process.env.VUE_APP_API_HOST,
  project: process.env.VUE_APP_API_PROJECT,
  storage: window.localStorage
});

/*
 * Interceptor to handle unauthorized requests
 */
client.axios.interceptors.response.use(
  function(response) {
    // All fine
    return response;
  },
  function(error) {
    // Redirect to login if authentication is required
    // ToDo: Exclude login requests
    if (error.response.status === 401 || error.response.status === 403) {
      console.log('status 401, 403', { error });

      let title = i18n.t('Error');
      let message = i18n.t('No valid authentification. Please login again.');

      // if (error.response.data && error.response.data.error && error.response.data.error.message) {
      //     message = error.response.data.error.message;
      // }

      Vue.prototype.$notify({
        type: 'error',
        title: title,
        message: message,
        duration: 8000,
        showClose: true
      });

      // Clear local storage
      clearUserData();

      // Redirect to login
      router.push({ path: '/login' });

      return Promise.reject(error);
    }

    // let responseError = error.response.data;

    // console.log('error', { error });

    // Show message for all kinds of errors
    // Vue.prototype.$notify({
    // 	type: 'error',
    // 	title: responseError.statusCode || error.response.status,
    // 	message: responseError.errorMessage || error.response.statusText,
    // 	duration: 8000,
    // 	showClose: true
    // });

    // Display all errors from backend.
    // These are mostly validation errors.
    // if (error.response.data.hasOwnProperty('error')) {
    //     console.log('hat fehler');

    //     Vue.prototype.$notify({
    //         type: 'error',
    //         title: i18n.t('Error'),
    //         message: error.response.data.error.message,
    //         duration: 0,
    //         showClose: true
    //     });
    // }

    return Promise.reject(error);
  }
);

export default client;
